import Swal from "sweetalert2";
import {
    loadingToggleAction,
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import apiService from '../service';
import axios, { Axios } from "axios";
import { useDispatch } from "react-redux";
export function verifyAppIdService(regNo) {
    return apiService.post("/reg/fetchUserByRegNo?regNo=" + regNo
    );
}
export function authenticateUserService(regNo) {
    const postData = {
        "regNo": regNo,
    };
    return apiService.post("/auth/authenticateUser",
        postData,
    );
}

export function login(regNo, otp) {
    const postData = {
        "regNo": regNo,
        "onetimepassword": otp
    };
    return apiService.post("/auth/authorizeUser",
        postData,
    );
}

export function formatError(errorResponse) {
    Swal.fire({
        icon: 'error',
        title: 'Oops',
        text: errorResponse,
        allowOutsideClick: false
    })
}
export function formatAuthError(errorResponse) {
    Swal.fire({
        icon: 'error',
        title: 'The login token is not valid anymore which may indicate a compromised account. Please check your account for unusual activities.',
        text: errorResponse,
        allowOutsideClick: false
    })
}

export function formatSuccess(successMessage) {
    Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: successMessage,
        allowOutsideClick: false
    })
}


export function saveTokenInLocalStorage(tokenDetails) {
    tokenDetails.expireDate = new Date(
        new Date().getTime() + tokenDetails.expiresIn * 1000,
    );
    sessionStorage.setItem('userDetails', JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = sessionStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }

    dispatch(loginConfirmedAction(tokenDetails));
    // navigate("/home")

    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
export function fetchLoggedInUser() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/reg/fetchUser", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function fetchPrivileges() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/auth/privileges", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}

axios.interceptors.request.use(function (config) {
    const dispatch = useDispatch();
    dispatch(loadingToggleAction(true))
    return config
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    const dispatch = useDispatch();
    dispatch(loadingToggleAction(false))
    return response;
}, function (error) {
    return Promise.reject(error);
});

